import { debounce, map } from 'lodash'
import { useRef, useCallback, useContext, useEffect } from 'react'
import { PageLoadContext } from '@core/providers/PageLoadContext'

export default (duration = 500) => {
  const callbackPool = useRef([])
  const pageLoad = useContext(PageLoadContext)
  const initialWork = useRef(new Map())
  useEffect(() => {
    const work = initialWork.current
    return () => {
      work.forEach((finish) => finish())
      work.clear()
    }
  }, [])

  return useCallback(
    (wrapperFn) =>
      (...args) => {
        const finish = pageLoad?.begin()
        const callback = debounce(() => {
          try {
            return wrapperFn(...args)
          } finally {
            finish?.()
            initialWork.current.delete(callback)
          }
        }, duration)

        if (callbackPool.current.length > 0) {
          map(callbackPool.current, (debounce) => {
            debounce.cancel()
            initialWork.current.get(debounce)?.()
            initialWork.current.delete(debounce)
          })
          callbackPool.current = []
        }

        callbackPool.current.push(callback)
        if (finish) initialWork.current.set(callback, finish)
        callback()
      },
    [duration, pageLoad]
  )
}
